import { render } from "./Modal-Base.vue?vue&type=template&id=1abf8546&scoped=true"
import script from "./Modal-Base.vue?vue&type=script&lang=js"
export * from "./Modal-Base.vue?vue&type=script&lang=js"

import "./Modal-Base.vue?vue&type=style&index=0&id=1abf8546&scoped=true&lang=css"

import exportComponent from "../../../momsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abf8546"]])

export default __exports__